import { cn } from "@theprelude/core";

export const TaniumIcon: React.FC<React.ComponentPropsWithoutRef<"svg">> = ({
  className,
  ...props
}) => (
  <svg
    className={cn("size-4 flex-shrink-0", className)}
    {...props}
    viewBox="0 0 24 26"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7.39026 11.1801H23.8663C23.5231 8.90906 22.5354 6.7842 21.0204 5.05785C19.5054 3.3315 17.5268 2.0762 15.3195 1.44102C13.1123 0.805833 10.7691 0.817451 8.56823 1.47449C6.36737 2.13153 4.40131 3.40639 2.90351 5.14768C1.40572 6.88896 0.43911 9.02352 0.118481 11.2979C-0.202148 13.5722 0.136669 15.8908 1.0947 17.9783C2.05273 20.0658 3.58972 21.8345 5.52316 23.0744C7.4566 24.3143 9.70525 24.9732 12.0021 24.973C12.5631 24.9717 13.1233 24.9317 13.6787 24.8532V14.9257H7.39026V11.1801Z" />
    <path d="M18.1486 23.276C19.6481 22.3807 20.9342 21.1691 21.9173 19.7257C22.9004 18.2823 23.5567 16.6418 23.8406 14.9186H18.1486V23.276Z" />
  </svg>
);
